import boardRequestsSlice from "./board/board";
import connectionsRequestsSlice from "./connections/connections";
import gmcRequestsSlice from "./gmc/gmc";
import itemRequestsSlice from "./item/item";
import stageRequestsSlice from "./stage/stage";
import userRequestsSlice from "./user/user";

export const { useGetUserQuery, useUpdateUsersPermissionsMutation, useGetUsersPermissionsQuery } =
  userRequestsSlice;

export const { useConnectionStatusQuery, useLazyConnectionStatusQuery, useDisconnectGooleMutation } =
  connectionsRequestsSlice;

export const { useUpdateStageMutation } = stageRequestsSlice;

export const { useMerchantAccountsListQuery, useGetDashboardQuery, useLazyGetReportQuery } = gmcRequestsSlice;

export const { useUpdateMerchantIdMutation } = itemRequestsSlice;

export const {
  useGmcMappingOptionsQuery,
  useGetDataMappingQuery,
  useSubmitDataMappingMutation,
  useLazySyncBoardQuery,
} = boardRequestsSlice;
